import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { MenuClient, MenuStringModel } from "@/api-client/menu-client";
import { Getter, Mutation } from "vuex-class";
import { isEmpty } from "@/core/misc";

import EventBus from "@/lib/EventBus";

@Options({
    name: "top-horizontal-component",
    components: {},
})
export default class TopHorizontalMenu extends Vue {
    @Getter("getIsFullScreen") isFullScreen!: boolean;

    @Mutation("openSearchDrawerMobile") openSearchDrawerMobile!: () => {};
    @Mutation("setActiveTab_Mobile") setActiveTab_Mobile!: (val: string) => {};
    @Mutation("setIsMobile") setIsMobile!: (value: boolean) => {};
    @Mutation("setScrollToMap") setScrollToMap!: (value: boolean) => {};

    private menuService = new MenuClient();

    menus: Array<any> = [];
    isLoading = false;
    menuString = "";
    menuDrawer = false;
    menuDrawerSize = "380px";

    expandSubMenus: Array<number> = [];
    isMobile = true;
    isLoadingMenu = false;
    menuStringObject: MenuStringModel = {};

    beforeMount() {
        this.getIsMobile();
        this.setIsMobile(this.isMobile);
        this.initMenu();
        this.getSizeMenuDrawerMobile();

        window.addEventListener("resize", () => {
            this.getIsMobile();
            this.setIsMobile(this.isMobile);

            this.getSizeMenuDrawerMobile();
        });
    }

    mounted() {
        if (!this.isMobile && isEmpty(this.menuStringObject.HTML)) {
            this.getMenuDesktopString();
        }
    }

    beforeDestroy() {
        window.removeEventListener("resize", () => {});
    }

    processHtmlString() {
        let ul = window.document.querySelector("ul.menu-top");
        let lis = ul?.querySelectorAll("li");
        lis?.forEach((li) => {
            let li_text = li.querySelector("a")?.innerHTML;

            if (li_text === "TRANG CHỦ") {
                (li as HTMLElement).classList.remove("active");
            } else if (li_text === "THÔNG TIN QUY HOẠCH") {
                (li as HTMLElement).classList.add("active");
            }
        });
    }

    getIsMobile() {
        const width = window.innerWidth;
        if (width < 1020) {
            this.isMobile = true;
        } else this.isMobile = false;
    }

    toggleSubMenu(val: number) {
        const currentIndex = this.expandSubMenus.indexOf(val);
        if(currentIndex > -1) {
            this.expandSubMenus.splice(currentIndex, 1);
        } else {
            this.expandSubMenus.push(val);
        }
    }

    closeDrawer() {
        this.menuDrawer = false;
    }

    isEmpty(val: any) {
        return isEmpty(val);
    }

    initMenu() {
        const baseUrl = window.location.host;

        this.menus = [
            {
                name: "TRANG CHỦ",
                path: baseUrl + "/",
            },
            {
                name: "GIỚI THIỆU TIỀM NĂNG",
                // path: baseUrl + "/gioi-thieu-tiem-nang",
                path: "",
                child: [
                    {
                        name: "TIỀM NĂNG, THẾ MẠNH",
                        path: baseUrl + "/tiem-bang-the-manh",
                    },
                    {
                        name: "CHÍNH SÁCH ĐẶC THÙ",
                        path: baseUrl + "/chinh-sach-dac-thu",
                    },
                ],
            },
            {
                name: "DỰ ÁN KÊU GỌI ĐẦU TƯ",
                path: baseUrl + "/du-an-dau-tu",
            },
            {
                name: "THÔNG TIN QUY HOẠCH",
                path: baseUrl + "/ban-do",
            },
            {
                name: "TRÌNH TỰ THỦ TỤC",
                // path: baseUrl + "/trinh-tu-thu-tuc",
                path: "",
                child: [
                    {
                        name: "HƯỚNG DẪN TRÌNH TỰ THỦ TỤC",
                        path: baseUrl + "/huong-dan-trinh-tu-thu-tuc",
                    },
                    {
                        name: "DỰ ÁN ĐẤU THẦU, ĐẤU GIÁ",
                        path: baseUrl + "/du-an-dau-thau-dau-gia",
                    },
                    {
                        name: "DỰ ÁN CHẤP THUẬN NHÀ ĐẦU TƯ",
                        path: baseUrl + "/du-an-chap-thuan-nha-dau-tu",
                    },
                ],
            },
            {
                name: "TIN TỨC",
                path: baseUrl + "/tin-tuc",
            },
            {
                name: "THƯ VIỆN",
                path: baseUrl + "/thu-vien",
            },
            // {
            //     name: "CÂU HỎI THƯỜNG GẶP",
            //     path: baseUrl + "/cau-hoi-thuong-gap",
            // },
        ];
    }

    getMenuDesktopString() {
        // this.emitter.emit("scroll-to-top");
        this.isLoadingMenu = true;
        this.menuService.getMenuString("desktop").then(
            (res) => {
                this.isLoadingMenu = false;
                if (res && res.resultObject) {
                    this.menuStringObject = res.resultObject;
                    this.menuStringObject.HTML = (res.resultObject.HTML || "").replace("\n", "");
                    this.menuStringObject.HTML = (res.resultObject.HTML || "").replace(/\\/g, "");

                    this.menuStringObject.HTML = (res.resultObject.HTML || "").replace(/\\/g, "");

                    let baseUrl = window.location.protocol + "//" + window.location.host;
                    if (window.location.host === "localhost:8080") {
                        baseUrl = "http://localhost:8036";
                    }

                    this.menuStringObject.HTML = (res.resultObject.HTML || "").replace("/Content/images/", baseUrl + "/Content/images/");


                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace("\r", "");
                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace("\n", "");
                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace('/\\"/g', '');
                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace(/\\/g, "");

                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace("/* header */", "");
                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace("/* end header */", "");

                    // this.menuStringObject.CSS = (res.resultObject.CSS || "").replace('"', "");

                    setTimeout(() => {
                        EventBus.emit("scroll-to-map");
                        // this.setScrollToMap(true);

                        let ul = window.document.querySelector("ul.menu-top");
                        let lis = ul?.querySelectorAll("li");
                        lis?.forEach((li) => {
                            let li_text = li.querySelector("a")?.innerHTML;

                            if (li_text === "TRANG CHỦ") {
                                (li as HTMLElement).classList.remove("active");
                            } else if (li_text === "THÔNG TIN QUY HOẠCH") {
                                (li as HTMLElement).classList.add("active");
                            }
                        });
                    }, 300);
                }
            },
            (err) => {
                this.isLoadingMenu = false;
            }
        );
    }

    goToPage(path: string) {
        if (!isEmpty(path)) {
            window.location.href = window.location.protocol + "//" + path;
        }
    }

    openMenuMobile() {
        this.menuDrawer = true;
    }

    openSearchDrawer() {
        // this.emitter.emit("tabName");
        this.openSearchDrawerMobile();
        this.setActiveTab_Mobile("DuAnKeuGoiDauTu");
    }

    getSizeMenuDrawerMobile() {
        const screenWidth = window.innerWidth;

        if (screenWidth <= 410) {
            this.menuDrawerSize = "80%";
        } else this.menuDrawerSize = "380px";
    }

    @Watch("isMobile") handleChange_isMobile(val: boolean, oldVal: boolean) {
        
        if (val) {
            this.scrollToTop();
        } else {
            if (isEmpty(this.menuStringObject.HTML)) {
                this.getMenuDesktopString();
            } else {
                setTimeout(() => {
                    this.processHtmlString();
                }, 300);
            }
        }
    }

    scrollToTop() {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 300); // setTimeout cho đẹp thôi, khỏi cũng được
    }

    // initMenu() {
    //     this.isLoading = true;
    //     this.menuService.getMenuString("TOP").then((res) => {
    //         this.isLoading = false;
    //         this.menuString = res?.data ? res.data : "";
    //
    //         this.menuString =
    //             `<div class="contact">
    //                         <ul class="ulLinks">
    //                             <li class="row">
    //                                 <div class="col-4"></div>
    //                                 <div class="col-3">
    //                                     <div style="float: right"><i class="icon-call mr10" aria-hidden="true"></i>Liên hệ: 0258.3822906</div>
    //                                 </div>
    //                                 |
    //                                 <div class="col-4"><i class="icon-mail mr10" aria-hidden="true"></i>skhdt@khanhhoa.gov.vn</div>
    //                             </li>
    //                         </ul>
    //                     </div>` + this.menuString;
    //     });
    // }
}
